import { IIcon } from "@geotab/zenith";
import { DriveStore } from "../../../../../store/reducers";
import React from "react";
import { PageLevel } from "../../../../../store/mobile/types";
import { IWorkflowState, TWorkflowStep } from "../../../../../ui/workflow";
import rison from "rison";
import { dispatcher, DispatcherEvents } from "../../../../../utils/dispatcher";

export interface ItemListData {
    id: string;
    primary: string;
    secondary?: string;
    icon?: React.FC<IIcon> | React.ReactNode;
    onClick?: () => void;
    status?: React.ReactNode;
    displayError?: boolean;
}

export const getPageState = (store: DriveStore) => {
    return store.getState().mobile.pageState;
};

const isChangingVehicle = (store: DriveStore) => {
    return getPageState(store).pageLevel === PageLevel.RETURN_ASSETS;
};

const isLogin = (store: DriveStore) => {
    return getPageState(store).pageLevel === PageLevel.FORCE_LOGOUT;
};

export const isDoingDvir = (store: DriveStore) => {
    return getPageState(store).pageLevel === PageLevel.ASSET_SPECIFIC_PAGE;
};

export const isLogout = (store: DriveStore) => {
    return getPageState(store).pageLevel === PageLevel.RETURN_DASHBOARD;
};

export const isShowingBackButton = (store: DriveStore) => {
    const pageState = getPageState(store);
    let level = pageState.pageLevel;
    return level === PageLevel.TWO || level === PageLevel.ASSET_SPECIFIC_PAGE || level === PageLevel.SUBMENU_WITH_BACK_BUTTON;
};

export const hidingIcons = (store: DriveStore) => {
    return getPageState(store).pageLevel === PageLevel.ZERO;
};

export const isWorkflow = (store: DriveStore) => {
    return isLogin(store) || isLogout(store) || isChangingVehicle(store);
};

export const toWorkflow = (router: Backbone.Router, isLogoutWorkFlow = false, nextPageState: IWorkflowState = {}, skipWorkflow?: boolean) => {
    let step: TWorkflowStep;
    if (isLogoutWorkFlow) {
        step = "checkPostTrip";
    } else {
        // Codriver clocking in, then skip to verify logs
        if ((nextPageState && nextPageState.coDriver)) {
            step = "showAvailability";
        } else if ((nextPageState && nextPageState.step)) {
            step = nextPageState.step;
        } else {
            step = "selectVehicle";
        }
    }

    // Override the step
    nextPageState.step = step;
    nextPageState.isLogout = isLogoutWorkFlow;
    if (skipWorkflow) {
        nextPageState.skipWorkflow = true;
    }
    dispatcher.trigger(DispatcherEvents.HideToastMessage);
    router.navigate("workflow," + rison.encode(nextPageState), true);
};

